import gql from 'graphql-tag'
import { listUsers } from './fragments'

export default gql`
query listUsers($filter: UserFilterArgs, $params: ListQueryArgs) {
	cashAssist {
		listUsers(filter: $filter, params: $params) {
			...listUsers
		}
	}
}
${listUsers}`
